import React from 'react'
import styles from '@styles/components/FireflyCreditWarningToast.module.scss'
import { useFireflyActions, useFireflyState } from '@hooks/useFirefly'
import { useTranslations } from 'use-intl'
import { FireflyToast } from './FireflyToast/FireflyToast'
import { FireflyToastCloseButton } from './FireflyToast/FireflyToastCloseButton'
import { FireflyUpgradeButton } from './FireflyUpgradeButton'

export function FireflyCreditWarningToast() {
  const t = useTranslations()

  const showCreditWarningToast = useFireflyState('showCreditWarningToast')
  const { setShowCreditWarningToast, setShowPaywall } = useFireflyActions()

  function handleClose() {
    setShowCreditWarningToast(false)
  }

  function handleUpgrade() {
    setShowPaywall('quota')
    setShowCreditWarningToast(false)
  }

  return (
    <FireflyToast visible={showCreditWarningToast}>
      <div className={styles['content']}>
        <div className={styles['content-left-side']}>
          <p>{t('studio:firefly:creditWarning:toast:description')}</p>
          <FireflyUpgradeButton onClick={handleUpgrade}>
            {t('studio:firefly:paywall:toast:cta-button')}
          </FireflyUpgradeButton>
        </div>
        <FireflyToastCloseButton onClick={handleClose} />
      </div>
    </FireflyToast>
  )
}
